import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCab = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M13.919 1.5H10.08c-.776 0-1.415.57-1.566 1.326l-.496 2.478A1 1 0 0 0 9 6.5h6a1 1 0 0 0 .98-1.196l-.495-2.478c-.151-.757-.79-1.326-1.566-1.326Zm-.34 2 .201 1h-3.561l.201-1h3.159ZM16.5 10.5a1 1 0 0 1 .117 1.993l-.117.007h-9a1 1 0 0 1-.117-1.993L7.5 10.5h9Z"
        fillRule="nonzero"
      />
      <g transform="translate(2 5.5)">
        <path
          d="m5.103-1-.18.005A3 3 0 0 0 2.18 1.32L1.162 4.803l.05-.027A4 4 0 0 0-1 8.355V12l.005.164a2.5 2.5 0 0 0 2.33 2.33l.207.006.003.02A3 3 0 0 0 4.5 17l.176-.005a3.002 3.002 0 0 0 2.743-2.3l.039-.195h5.084l.003.02A3.001 3.001 0 0 0 15.502 17l.176-.005a3.002 3.002 0 0 0 2.743-2.3l.038-.195h.041A2.5 2.5 0 0 0 21 12V8.354l-.006-.215a4 4 0 0 0-2.015-3.261l-.134-.072-.983-3.512C17.569-.025 16.352-1 14.947-1H5.103Zm0 2h9.844a1 1 0 0 1 .944.67l1.148 4.1a1 1 0 0 0 .515.625l.34.17A2 2 0 0 1 19 8.355V12a.5.5 0 0 1-.5.5h-.998a1 1 0 0 0-1 1v.5a1 1 0 1 1-2.002 0v-.5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v.5a1 1 0 0 1-2 0v-.5a1 1 0 0 0-1-1h-1A.5.5 0 0 1 1 12V8.355a2 2 0 0 1 1.106-1.79l.341-.17a1 1 0 0 0 .513-.614l1.155-3.955c.12-.506.523-.826.988-.826Z"
          fillRule="nonzero"
        />
        <circle cx={4.75} cy={9.75} r={1.25} />
        <circle cx={15.25} cy={9.75} r={1.25} />
      </g>
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgCab)
const Memo = memo(ForwardRef)
export default Memo
